module.exports = __webpack_public_path__ + "img/abinoid-face-toner.d8ac174d.jpg";